/**
 * Registered ids of the Flotte configurable components (plan `frontend.md`
 * "Component inventory"). The id is the rule contract — never rename one.
 */

export const FLEET_COMPONENT_IDS = {
  fleetList: 'extranet.fleetListCard',
  vehicleDetails: 'extranet.vehicleDetailsCard',
  vehicleContract: 'extranet.vehicleContractCard',
  vehicleGuarantees: 'extranet.vehicleGuaranteesCard',
  vehicleClaims: 'extranet.vehicleClaimsCard',
  vehicleDocuments: 'extranet.vehicleDocumentsCard',
} as const;

export type FleetComponentId = (typeof FLEET_COMPONENT_IDS)[keyof typeof FLEET_COMPONENT_IDS];
